@import '../../global/styles.css';

:host {
  display: block;
}
